var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgError4 = function SvgError4(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 1.29289C7.48043 1.10536 7.73478 1 8 1H16.5C16.7803 1 17.0477 1.11765 17.2372 1.32428L22.7372 7.32428C22.9062 7.50871 23 7.74981 23 8V16C23 16.2502 22.9062 16.4913 22.7372 16.6757L17.2372 22.6757C17.0477 22.8824 16.7803 23 16.5 23H8C7.73478 23 7.48043 22.8946 7.29289 22.7071L1.29289 16.7071C1.10536 16.5196 1 16.2652 1 16V8C1 7.73478 1.10536 7.48043 1.29289 7.29289L7.29289 1.29289ZM8.41421 3L3 8.41421V15.5858L8.41421 21H16.0601L21 15.611V8.38898L16.0601 3H8.41421Z",
    fill: "#DE3121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79289 7.79289C8.18342 7.40237 8.81658 7.40237 9.20711 7.79289L16.2071 14.7929C16.5976 15.1834 16.5976 15.8166 16.2071 16.2071C15.8166 16.5976 15.1834 16.5976 14.7929 16.2071L7.79289 9.20711C7.40237 8.81658 7.40237 8.18342 7.79289 7.79289Z",
    fill: "#DE3121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2071 7.79289C15.8166 7.40237 15.1834 7.40237 14.7929 7.79289L7.79289 14.7929C7.40237 15.1834 7.40237 15.8166 7.79289 16.2071C8.18342 16.5976 8.81658 16.5976 9.20711 16.2071L16.2071 9.20711C16.5976 8.81658 16.5976 8.18342 16.2071 7.79289Z",
    fill: "#DE3121"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-4.6ef166c3.svg";
export { ForwardRef as ReactComponent };